<template>
  <div
    @click="collapseMenus"
    class="container text-start"
    v-if="stakersAddress !== null"
  >
    <h2>
      <span class="animate-characters">Surviville Staking Center</span>
      &nbsp;

      <a href="#">
        <i title="Reload numbers" @click="reload" class="ri-refresh-fill"></i>
      </a>
    </h2>

    <button
      class="btn btn-danger"
      @click="setNewEmissionsPerSecondE10('svc0Staking')"
    >
      Set new emission for svc0Staking
    </button>

    &nbsp;

    <button class="btn btn-danger" @click="emergencyUnstake('svc0Staking')">
      Emergency unstake svc0Staking
    </button>

    <div class="row">
      <div class="col-xxl-6 mx-auto">
        <div class="card">
          <div class="card-body">
            <div class="col-12 align-items-left">
              <h4 class="animate-characters">{{ apy["svc0Staking"] }}% APY</h4>
              <br />
              <h4>Stake SVC -- get rewards each second</h4>
              &nbsp;
              <a
                target="_blank"
                href="https://app.mistswap.fi/swap?inputCurrency=BCH&outputCurrency=0xE7B1076d0853a7aAa6FbB477886726ed03C6Fffd"
                class="mt-2 mb-4"
              >
                Get SVC on MistSwap
              </a>
              <h5 class="mt-4 mb-2">
                Balance:
                {{ formatNumber(balanceE18[("svc", "staker")], 6) }} SVC --
                Staked:
                {{
                  formatNumber(
                    Number(stakerStakedE0["svc0Staking"]) / 10 ** 18,
                    6
                  )
                }}
                SVC
              </h5>
              <br />

              <h6>
                Total staked:
                {{
                  formatNumber(
                    Number(totalStakedE0["svc0Staking"]) / 10 ** 18,
                    3
                  )
                }}
                SVC
              </h6>
              <h6>
                Total Emission:
                {{
                  formatNumber(
                    svcEmissionPerHourE18["svc0Staking"] * earningsTime,
                    3
                  )
                }}
                SVC / {{ hoursInWords[earningsTime] }}
              </h6>

              <div class="settings-menu">
                <button
                  class="btn btn-std"
                  @click="harvest('svc0Staking')"
                  :disabled="rewardTokenToHarvestE18['svc0Staking'] == 0"
                >
                  Harvest
                  {{ formatNumber(rewardTokenToHarvestE18["svc0Staking"], 3) }}
                  SVC
                </button>

                &nbsp;

                <button
                  v-if="stakersAllowanceE18[('svc', 'svc0Staking')] > 0"
                  class="btn btn-std"
                  @click="stake('svc0Staking')"
                >
                  Stake all SVC
                </button>
                <button
                  v-else
                  class="btn btn-std"
                  @click="approveRewardToken('svc0Staking')"
                >
                  Approve
                </button>

                &nbsp;

                <button class="btn btn-std" @click="unstake('svc0Staking')">
                  Unstake all SVC
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="popup" v-if="txInProgress || feedbackMessage != ''">
    <div
      class="popupX"
      @click="
        feedbackMessage = '';
        txInProgress = false;
      "
    >
      x
    </div>
    <h4 v-if="feedbackMessage != ''" class="text-monospace animate-popup">
      {{ feedbackMessage }}
    </h4>
    <br />
    <h5 v-if="txInProgress" class="text-monospace animate-popup">
      Waiting for current transaction to finish...
    </h5>
  </div>
</template>

<script>
import { ethers } from "ethers";
import StakingRewards from "../../artifacts/contracts/StakingRewards.sol/StakingRewards.json";
import RewardToken from "../../artifacts/contracts/RewardToken.sol/RewardToken.json";

// let address['svc'] = window.ca['svc'];

export default {
  name: "App",

  data() {
    return {
      expand: {},

      contracts: {},

      provider: null,
      signer: null,

      stakersAddress: null,

      stakerStakedForSeconds: null,
      SECONDS_PER_DAY: 86400, // TODO 86400 = 1 day
      stakersPayoutPct: null,
      stakersNextPayoutPct: null,
      stakerNextPayoutPctInSeconds: null,

      balanceE0Str: {},
      balanceE18: {},
      stakersAllowanceE18: {},

      rewardTokenToHarvestE18: {},
      stakerStakedE0: {},
      totalStakedE0: {},
      svcEmissionPerHourE18: {},

      stakersEarningRateE18: {},
      apy: {},

      earningsTime: 8760,
      hoursInWords: {
        1: "hour",
        24: "day",
        168: "week",
        720: "month",
        8760: "year",
      },

      feedbackMessage: "",
      txInProgress: false,
      lastTimeout: 0,
    };
  },
  methods: {
    collapseMenus: function () {
      this.expand["svc0Staking"] = false;
    },

    setFeedback: function (_text, _timeOut) {
      let that = this;
      that.feedbackMessage = _text;
      if (that.lastTimeout > 0) {
        clearTimeout(that.lastTimeout);
      }
      if (_timeOut > 0) {
        that.lastTimeout = setTimeout(function () {
          that.feedbackMessage = "";
        }, _timeOut);
      }
    },

    formatNumber: function (_number, _decimals) {
      _number = Number(_number);
      if (_number < 1) {
        return String(_number);
      }

      const _symbols = ["", "k", "M", "G", "T"];
      let returnString = "";
      for (let _idx = _symbols.length - 1; _idx >= 0; --_idx) {
        const _exp = 3 * _idx;
        const _testNumber = _number / 10 ** _exp;
        if (_testNumber >= 1) {
          // get rid off unnecessary decimals
          const _intLength = String(Math.round(_testNumber)).length;
          _number =
            Math.round(_number * 10 ** (_decimals + _intLength + _exp)) /
            10 ** (_decimals + _intLength + _exp);

          returnString =
            Math.floor(_number / 10 ** (_exp - _decimals)) / 10 ** _decimals +
            _symbols[_idx];
          return returnString;
        }
      }
    },

    txError: function (err) {
      this.setFeedback("The transaction failed :(", 2000);
      this.txInProgress = false;
      const code = err.data.replace("Reverted ", "");
      console.log({ err });
      let reason = ethers.utils.toUtf8String("0x" + code.substr(138));
      console.log("revert reason:", reason);
    },

    emergencyUnstake: async function (_stakingContract) {
      this.txInProgress = false;

      try {
        let tx = await this.contracts[_stakingContract].emergencyUnstake();
        await tx.wait();

        this.feedbackMessage = "";
      } catch (err) {
        this.txError(err);
      }
      this.txInProgress = false;

      this.reload();
    },

    setNewEmissionsPerSecondE10: async function (_stakingContract) {
      let _amount = 317098;
      this.txInProgress = false;

      try {
        let tx = await this.contracts[
          _stakingContract
        ].setNewEmissionsPerSecondE10(_amount);
        await tx.wait();

        this.feedbackMessage = "";
      } catch (err) {
        this.txError(err);
      }
      this.txInProgress = false;

      this.reload();
    },

    stake: async function (_stakingContract) {
      if (Number(this.balanceE0Str[("svc", "staker")]) <= 0) {
        this.setFeedback("Nothing to stake", 2000);
        return false;
      }

      const _amountStr = this.balanceE0Str[("svc", "staker")];

      await this.getAllowanceE18("svc", _stakingContract);

      if (
        this.stakersAllowanceE18[("svc", _stakingContract)] <
        this.balanceE0Str[("svc", "staker")]
      ) {
        this.setFeedback("Approve the contract first", 2000);
        return false;
      }

      this.setFeedback(
        `Staking ${this.formatNumber(Number(_amountStr) / 10 ** 18, 3)} SVC`,
        0
      );
      this.txInProgress = true;

      try {
        let tx = await this.contracts[_stakingContract].stake(_amountStr);
        await tx.wait();

        this.feedbackMessage = "";
      } catch (err) {
        this.txError(err);
      }
      this.txInProgress = false;

      this.reload();
    },

    unstake: async function (_stakingContract) {
      if (this.stakerStakedE0["svc0Staking"] <= 0) {
        this.setFeedback("Nothing to unstake", 2000);
        return false;
      }

      const _amount = this.stakerStakedE0["svc0Staking"].toString();

      this.setFeedback(
        `Unstaking ${this.formatNumber(_amount / 10 ** 18, 3)} SVC`,
        0
      );
      this.txInProgress = true;

      try {
        let tx = await this.contracts[_stakingContract].unstake(_amount);
        await tx.wait();

        this.feedbackMessage = "";
      } catch (err) {
        this.txError(err);
      }
      this.txInProgress = false;

      this.reload();
    },

    harvest: async function (_stakingContract) {
      this.setFeedback("Harvesting your earnings", 0);
      this.txInProgress = true;

      try {
        let tx = await this.contracts[_stakingContract].harvest();
        await tx.wait();

        this.feedbackMessage = "";
      } catch (err) {
        this.txError(err);
      }
      this.txInProgress = false;

      this.reload();
    },

    getAllowanceE18: async function (_token, _stakingContract) {
      let that = this;

      return new Promise((resolve, reject) => {
        try {
          that.contracts[_token]
            .allowance(that.stakersAddress, window.ca[_stakingContract])
            .then((allowance) => {
              that.stakersAllowanceE18[(_token, _stakingContract)] =
                Math.round(allowance / 10 ** 14) / 10 ** 4;
              resolve();
            });
        } catch {
          reject();
        }
      });
    },

    approveRewardToken: async function (_stakingContract) {
      let that = this;

      that.setFeedback("Approving SVC token", 0);
      that.txInProgress = true;

      try {
        let tx = await that.contracts["svc"].approve(
          window.ca[_stakingContract],
          ethers.constants.MaxUint256,
          {
            gasLimit: 65000, // 60k is probably fine, too
          }
        );
        // gasPrice: 1046740000,
        await tx.wait();
        that.contracts["svc"]
          .allowance(that.stakersAddress, window.ca[_stakingContract])
          .then((allowance) => {
            that.stakersAllowanceE18[_stakingContract] = allowance / 10 ** 18;
          });
        that.feedbackMessage = "";
        that.txInProgress = false;
      } catch (err) {
        this.txError(err);
      }
    },

    // formatSeconds: function (seconds) {
    //   seconds = Number(seconds);
    //   var d = Math.floor(seconds / (3600 * 24));
    //   var h = Math.floor((seconds % (3600 * 24)) / 3600);
    //   var m = Math.floor((seconds % 3600) / 60);
    //   var s = Math.floor(seconds % 60);

    //   var dDisplay = d > 0 ? d + " d, " : "";
    //   var hDisplay = h > 0 ? h + " h, " : "";
    //   var mDisplay = m > 0 ? m + " min, " : "";
    //   var sDisplay = s + " sec";
    //   return dDisplay + hDisplay + mDisplay + sDisplay;
    // },

    loadStakerInfo: function (_stakingContract) {
      this.contracts[_stakingContract]
        .showStakerInfo(this.stakersAddress)
        .then((stakerInfo) => {
          console.log(stakerInfo);

          this.rewardTokenToHarvestE18[_stakingContract] = String(
            Math.round(stakerInfo[0] / 10 ** (18 + 15)) / 10 ** 3
          );
          this.stakerStakedE0[_stakingContract] = String(stakerInfo[1]);
          this.totalStakedE0[_stakingContract] = String(stakerInfo[2]);
          this.svcEmissionPerHourE18[_stakingContract] =
            (stakerInfo[3] / 10 ** 8) * 3600;
          this.stakersEarningRateE18[_stakingContract] =
            (((stakerInfo[3] / 10 ** 8) * 3600) / Math.max(1, stakerInfo[2])) *
            stakerInfo[1];
          let n = 365 * 24;
          let r =
            (this.svcEmissionPerHourE18[_stakingContract] * 10 ** 18) /
            this.totalStakedE0[_stakingContract];
          this.apy[_stakingContract] =
            Math.ceil(((1 + r) ** n - 1) * 10000) / 100;
        });
    },

    getRewardTokenBalance: function () {
      // console.log(this.stakersAddress);
      this.contracts["svc"].balanceOf(this.stakersAddress).then((balance) => {
        this.balanceE0Str[("svc", "staker")] = String(balance);
        this.balanceE18[("svc", "staker")] = balance / 10 ** 18;
      });
    },

    reload: function () {
      this.collapseMenus();
      this.getRewardTokenBalance();
      this.loadStakerInfo("svc0Staking");
      this.getAllowanceE18("svc", "svc0Staking");
    },

    load: function () {
      this.signer.getAddress().then((userAddress) => {
        this.stakersAddress = userAddress;
        this.reload();
      });
    },
  },

  mounted: function () {
    this.provider = new ethers.providers.Web3Provider(window.ethereum, "any");

    this.provider
      .send("eth_requestAccounts", [])
      .then(() => {
        this.signer = this.provider.getSigner();

        this.contracts["svc"] = new ethers.Contract(
          window.ca["svc"],
          RewardToken.abi,
          this.signer
        );

        this.contracts["svc0Staking"] = new ethers.Contract(
          window.ca["svc0Staking"],
          StakingRewards.abi,
          this.signer
        );
      })
      .then(() => {
        this.load();
      });
  },
};
</script>
